export const devices_config_wave = {
	'QNSW-001X16': {
		name: 'ShellyZwave1',
		friendly_name: 'Zwave 1',
		family: 'relay',
		isPM: false,
		modes: {
			relay: {
				channels: 1,
				settings: [
					//settings can be find inside src/helpers/z_wave_settings_config.ts
				],
			},
		},
	},
	'QNSW-001P16': {
		name: 'ShellyZwave1PM',
		friendly_name: 'Zwave 1 PM',
		family: 'relay',
		isPM: true,
		modes: {
			relay: {
				channels: 1,
				settings: [],
			},
		},
	},
	'QNSW-002P16': {
		name: 'ShellyZwave2Pm',
		friendly_name: 'Zwave 2 PM',
		family: 'relay',
		isPM: true,
		modes: {
			relay: {
				channels: 2,
				settings: [],
			},
		},
	},
	'QNSH-001P10': {
		name: 'ShellyZwaveShutter',
		friendly_name: 'Zwave Shutter',
		family: 'roller',
		isPM: true,
		modes: {
			roller: {
				channels: 1,
				settings: [],
			},
		},
	},
	'QNSN-0A24X': {
		name: 'ShellyZwaveI4',
		friendly_name: 'Zwave I4',
		family: 'inputs reader',
		isPM: false,
		modes: {
			roller: {
				channels: 1,
				settings: [],
			},
		},
	},
	'QNSN-0D24X': {
		name: 'ShellyZwaveI4DC',
		friendly_name: 'Zwave I4 DC',
		family: 'inputs reader',
		isPM: false,
		modes: {
			roller: {
				channels: 1,
				settings: [],
			},
		},
	},
	'QNPL-001X16': {
		name: 'ShellyZwavePlugUK',
		friendly_name: 'Zwave Plug UK',
		family: 'relay',
		isPM: false,
		modes: {
			roller: {
				channels: 1,
				settings: [],
			},
		},
	},
	'QNPL-001X12': {
		name: 'ShellyZwavePlugUS',
		friendly_name: 'Zwave Plug US',
		family: 'relay',
		isPM: false,
		modes: {
			roller: {
				channels: 1,
				settings: [],
			},
		},
	},
	'QPSW-0A1X16': {
		name: 'ShellyZwavePro1',
		friendly_name: 'Zwave Pro 1',
		family: 'relay',
		isPM: false,
		modes: {
			roller: {
				channels: 1,
				settings: [],
			},
		},
	},
	'QPSW-0A2X16': {
		name: 'ShellyZwavePro2',
		friendly_name: 'Zwave Pro 2',
		family: 'relay',
		isPM: false,
		modes: {
			roller: {
				channels: 2,
				settings: [],
			},
		},
	},
	'QPSW-0A1P16': {
		name: 'ShellyZwavePro1PM',
		friendly_name: 'Zwave Pro 1 PM',
		family: 'relay',
		isPM: true,
		modes: {
			roller: {
				channels: 1,
				settings: [],
			},
		},
	},
	'QPSW-0A2P16': {
		name: 'ShellyZwavePro2PM',
		friendly_name: 'Zwave Pro 2 PM',
		family: 'relay',
		isPM: true,
		modes: {
			roller: {
				channels: 2,
				settings: [],
			},
		},
	},
};
